"use strict";

var _taggedTemplateLiteral = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js").default;
var _slicedToArray = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _templateObject, _templateObject2;
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var _ownKeys = function ownKeys(o) {
    _ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return _ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = _ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AtomSentimentLine = exports.AtomSentimentLineGradient = void 0;
var react_1 = __importStar(require("react"));
var d3_1 = require("d3");
var styled_components_1 = __importDefault(require("styled-components"));
var AtomAxis_1 = __importDefault(require("../common/AtomAxis"));
var luxon_1 = require("luxon");
var hooks_1 = require("../helpers/hooks");
var AtomCrosshair_1 = __importDefault(require("../common/AtomCrosshair"));
var AtomSVGTooltip_1 = __importDefault(require("../common/AtomSVGTooltip"));
var AtomSentimentLineGradient = function AtomSentimentLineGradient(_ref) {
  var data = _ref.data,
    yScale = _ref.yScale,
    xScale = _ref.xScale,
    sentimentDirection = _ref.sentimentDirection;
  var areaGen = (0, d3_1.area)().x(function (d) {
    return xScale(new Date(d.date));
  }).y0(yScale(0)).y1(function (d) {
    return yScale(d.avgSentimentScore30Days);
  }).curve(d3_1.curveMonotoneX);
  var path = areaGen(data);
  if (!path) return null;
  return react_1.default.createElement("path", {
    className: 'area-line',
    d: path,
    fill: "url(#gradient-".concat(sentimentDirection, ")")
  });
};
exports.AtomSentimentLineGradient = AtomSentimentLineGradient;
var AtomSentimentLine = function AtomSentimentLine(_ref2) {
  var data = _ref2.data,
    xScale = _ref2.xScale,
    yScale = _ref2.yScale;
  var lineGen = (0, d3_1.line)().defined(function (d) {
    return d.avgSentimentScore30Days !== null;
  }).x(function (d) {
    return xScale(new Date(d.date));
  }).y(function (d) {
    return yScale(d.avgSentimentScore30Days);
  }).curve(d3_1.curveMonotoneX);
  var path = lineGen(data);
  if (!path) return null;
  return react_1.default.createElement("path", {
    className: 'sentiment-line',
    d: path
  });
};
exports.AtomSentimentLine = AtomSentimentLine;
var AtomSentimentLineChart = function AtomSentimentLineChart(_ref3) {
  var _ref3$resize = _ref3.resize,
    resize = _ref3$resize === void 0 ? 1 : _ref3$resize,
    data = _ref3.data,
    margin = _ref3.margin;
  var _ref4 = (0, react_1.useState)(undefined),
    _ref5 = _slicedToArray(_ref4, 2),
    hover = _ref5[0],
    setHover = _ref5[1];
  var _ref6 = (0, hooks_1.useSVGSize)(),
    _ref7 = _slicedToArray(_ref6, 2),
    svgRef = _ref7[0],
    _ref7$ = _ref7[1],
    width = _ref7$.width,
    height = _ref7$.height;
  var marginObj;
  if (margin === undefined) {
    var generatedMargin = width * 0.05;
    marginObj = {
      top: generatedMargin,
      right: generatedMargin,
      bottom: generatedMargin,
      left: generatedMargin
    };
  } else if (typeof margin === 'number') marginObj = {
    top: margin,
    right: margin,
    bottom: margin,
    left: margin
  };else marginObj = margin;
  var valueDomain = (0, d3_1.extent)(data, function (d) {
    return Math.round((d.avgSentimentScore30Days + Number.EPSILON) * 100) / 100;
  });
  if (valueDomain.reduce(function (t, v) {
    return t && v > 0;
  }, true)) valueDomain = [0, valueDomain[1]];else if (valueDomain.reduce(function (t, v) {
    return t && v < 0;
  }, true)) valueDomain = [valueDomain[0], 0];
  var yScale = (0, d3_1.scaleLinear)().domain(valueDomain).range([height - marginObj.bottom, marginObj.top]).nice();
  var dateData = data.sort(function (a, b) {
    return a.date - b.date;
  }).map(function (d) {
    return d.date;
  });
  var dateDomain = (0, d3_1.extent)(dateData);
  var xScale = (0, d3_1.scaleTime)().domain(dateDomain).range([marginObj.left, width - marginObj.right]);
  var getQuadrant = (0, react_1.useCallback)(function (x, y) {
    if (x > width / 2 && y < height / 2) return 1;
    if (x < width / 2 && y < height / 2) return 2;
    if (x < width / 2 && y > height / 2) return 3;
    if (x > width / 2 && y > height / 2) return 4;else return 1;
  }, [width, height]);
  var numTicks = 3;
  var sentimentFormat = (0, react_1.useCallback)(function () {
    var _yScale$domain = yScale.domain(),
      _yScale$domain2 = _slicedToArray(_yScale$domain, 2),
      start = _yScale$domain2[0],
      stop = _yScale$domain2[1];
    var step = (0, d3_1.tickStep)(start, stop, numTicks);
    if (step < 0.1) return (0, d3_1.format)('+.2f');else return (0, d3_1.format)('+.1f');
  }, [yScale]);
  var dateFormat = (0, d3_1.timeFormat)('%x');
  var onMouseMove = (0, react_1.useCallback)(function (e) {
    var _ref8 = (0, d3_1.pointer)(e),
      _ref9 = _slicedToArray(_ref8, 1),
      x = _ref9[0];
    var ms = luxon_1.DateTime.fromJSDate(xScale.invert(x)).toMillis();
    var index = (0, d3_1.bisect)(dateData, ms);
    var thisData = data[index];
    if (thisData) setHover(Object.assign({
      x: xScale(thisData.date),
      y: yScale(thisData.avgSentimentScore30Days)
    }, thisData));
  }, [dateData, data, xScale, yScale]);
  var sentimentDirection;
  if (valueDomain[0] < 0 && valueDomain[1] > 0) {
    sentimentDirection = 'sentiment-both';
  } else if (Math.abs(valueDomain[0]) < valueDomain[1]) {
    sentimentDirection = 'sentiment-up';
  } else sentimentDirection = 'sentiment-down';
  var offsetScale = (0, d3_1.scaleLinear)().domain([0, 1]).range([-height * 0.25, height * 0.25]);
  var zeroOffsetPoint = (0, react_1.useMemo)(function () {
    var zero = yScale(0) / height;
    var offset = offsetScale(zero) + Math.abs(marginObj.bottom - marginObj.top);
    return zero * 100 + offset;
  }, [marginObj.top, marginObj.bottom, height, offsetScale, yScale]);
  if (data.length === 0) return null;
  return react_1.default.createElement(StyledSVG, {
    ref: svgRef,
    direction: sentimentDirection,
    onMouseMove: onMouseMove,
    onMouseLeave: function onMouseLeave() {
      return setHover(undefined);
    }
  }, height > 0 && react_1.default.createElement("defs", null, sentimentDirection === 'sentiment-both' && react_1.default.createElement("linearGradient", {
    id: 'gradient-sentiment-both',
    x1: '0',
    x2: '0',
    y1: '0',
    y2: '1'
  }, react_1.default.createElement("stop", {
    offset: '0%',
    stopColor: 'var(--sentiment-up)',
    stopOpacity: '0.6'
  }), react_1.default.createElement("stop", {
    offset: "".concat(zeroOffsetPoint, "%"),
    stopColor: 'var(--background-primary)'
  }), react_1.default.createElement("stop", {
    offset: '100%',
    stopColor: 'var(--sentiment-down)',
    stopOpacity: '0.6'
  })), sentimentDirection === 'sentiment-up' && react_1.default.createElement("linearGradient", {
    id: 'gradient-sentiment-up',
    x1: '0',
    x2: '0',
    y1: '0',
    y2: '1'
  }, react_1.default.createElement("stop", {
    offset: '0%',
    stopColor: 'var(--sentiment-up)',
    stopOpacity: '0.4'
  }), react_1.default.createElement("stop", {
    offset: '100%',
    stopColor: 'var(--background-primary)'
  })), sentimentDirection === 'sentiment-down' && react_1.default.createElement("linearGradient", {
    id: 'gradient-sentiment-down',
    x1: '0',
    x2: '0',
    y1: '0',
    y2: yScale(0) / height
  }, react_1.default.createElement("stop", {
    offset: '0%',
    stopColor: 'var(--background-primary)'
  }), react_1.default.createElement("stop", {
    offset: '100%',
    stopColor: 'var(--sentiment-down)',
    stopOpacity: '0.4'
  }))), resize &&
  // see note about resize above
  data && data.length &&
  // only make visuals when there is data
  width > 0 && height > 0 &&
  // only render if there is svg space
  react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("line", {
    className: 'zero-line',
    x1: marginObj.left,
    x2: width - marginObj.right,
    y1: yScale(0),
    y2: yScale(0)
  }), react_1.default.createElement(exports.AtomSentimentLineGradient, {
    data: data,
    xScale: xScale,
    yScale: yScale,
    sentimentDirection: sentimentDirection
  }), react_1.default.createElement(exports.AtomSentimentLine, {
    data: data,
    xScale: xScale,
    yScale: yScale
  }), react_1.default.createElement(AtomAxis_1.default, {
    ticks: xScale.ticks(numTicks),
    scale: xScale,
    orientation: 'bottom',
    offset: [0, height - marginObj.bottom],
    format: dateFormat
  }), react_1.default.createElement(AtomAxis_1.default, {
    ticks: yScale.ticks(numTicks),
    scale: yScale,
    orientation: 'right',
    tickLength: width - (marginObj.left + marginObj.right),
    offset: [width - marginObj.right, 0],
    format: sentimentFormat()
  }), hover && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(AtomCrosshair_1.default, {
    x: hover.x,
    xVal: dateFormat(hover.date),
    y: hover.y,
    yVal: sentimentFormat()(hover.avgSentimentScore30Days),
    marginObj: marginObj,
    width: width,
    height: height,
    axisData: false
  }), react_1.default.createElement(AtomSVGTooltip_1.default, {
    x: hover.x,
    y: hover.y,
    quadrant: getQuadrant(hover.x, hover.y),
    innerHTML: react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(StyledRow, null, react_1.default.createElement("strong", null, "Date:"), ' ', dateFormat(luxon_1.DateTime.fromMillis(hover.date))), react_1.default.createElement(StyledRow, null, react_1.default.createElement("strong", null, "Sentiment:"), ' ', sentimentFormat()(hover.avgSentimentScore30Days)))
  }))));
};
var StyledSVG = styled_components_1.default.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n\n  * {\n    pointer-events: none;\n  }\n\n  .zero-line {\n    fill: none;\n    stroke: var(--highlight);\n    stroke-width: 1px;\n    stroke-dasharray: 4px;\n  }\n\n  .sentiment-line {\n    fill: none;\n    stroke: var(--", ");\n  }\n"])), function (_ref0) {
  var direction = _ref0.direction;
  return direction;
});
var StyledRow = styled_components_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: var(--text-primary);\n  font-size: 0.75em;\n"])));
exports.default = AtomSentimentLineChart;